export const igorAiProfileId = 1681241820069;
export const clientEmail = "user@provocator.ai";
export const adminEmail = `${import.meta.env.VITE_ADMIN_EMAIL}`;
export const personalAppOrganizationId = "personal";
export const minNumberOfCredits = 100;
export const testOrganizationId = "1234";
export const unknownEntityId = "unknown";
